import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FlexGrid, CellType } from '@grapecity/wijmo.grid';
import { Menu } from '@grapecity/wijmo.input';

import { DataGridUtil } from '../../../commons/kymw00/data-grid-util';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';

import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1403Model } from './kymw1403.model';
import { KYMW1403OutputModel } from './vo/kymw1403-output.model';
import { PublishGoodsDataModel } from '../kymw1400/vo/publish-goods-data.model';
import { GetPublishGoodsDataService } from './api-services/get-publish-goods-data.service';
import { faArrowAltCircleLeft, faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons';

/**
 * 掲載商品検索画面を管理するクラス
 *
 * @export KYMW1403Component
 * @class KYMW1403Component
 */
@Component({
  selector: 'app-kymw1403',
  templateUrl: 'kymw1403.component.html',
  styleUrls: ['kymw1403.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1403Component extends PlessViewHelperSub implements OnInit {
  @ViewChild('dg_SearchResult', { static: true }) dg_SearchResult: FlexGrid;
  @ViewChild('txt_OrderCodeFrom', { static: true }) txt_OrderCodeFrom: OrderCodeTextInputComponent;
  @ViewChild('txt_OrderCodeTo', { static: true }) txt_OrderCodeTo: OrderCodeTextInputComponent;

  setKYMW1403Parameter: Function = null;
  closeFunction: Function = null;
  kymw1403Model: KYMW1403Model = new KYMW1403Model();

  // コンテキストメニュー
  public contextMenu: Menu = null;

  /**
   * 検索条件VO
   */
  private publishGoodsDataVO: any = null;

  /**
   * DataGridの列名とテーブル物理名を紐付ける連想配列Object
   */
  private tableName: Object = null;

  iconPrev = faArrowAltCircleLeft;
  iconNext = faArrowAltCircleRight;

  /**
   *Creates an instance of KYMW1403Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {ElementRef} el
   * @param {KYMW00Model} kymw00Model
   * @param {GetPublishGoodsDataService} getPublishGoodsDataService
   * @memberof KYMW1403Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private elementRef: ElementRef,
    private kymw00Model: KYMW00Model,
    private getPublishGoodsDataService: GetPublishGoodsDataService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1403Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1403';
    // モデルクラスへ自コンポーネントを連携
    this.kymw1403Model.kymw1403Component = this;

    this.tableName = new Object();
    this.tableName['OrderCode'] = 'orderCode';
    this.tableName['DelivCatalogId'] = 'delivCatalogId';
    this.tableName['MediumName'] = 'mediumName';
    this.tableName['PlanCoopName'] = 'planCoopName';
    this.tableName['PageNum'] = 'pageNum';
    this.tableName['PageInfo'] = 'pageInfo';
    this.tableName['Pcode'] = 'pCode';
    this.tableName['GuideGoodsName'] = 'guideGoodsName';
    this.tableName['GuideStandardName'] = 'guideStandardName';

    // 「前へ」ボタン「次へ」ボタンを非活性にする
    this.kymw1403Model.disabledPreviousButton = true;
    this.kymw1403Model.disabledNextButton = true;

    // グリッド初期処理
    this.gridInit();

    // コンテキストメニュー設定
    this.setContextMenu();
  }

  /**
   * グリッド初期処理
   *
   * @private
   * @memberof KYMW1403Component
   */
  private gridInit() {
    this.dg_SearchResult.itemsSourceChanged.addHandler((sender, e) => {
      this.dg_SearchResult.select(-1, -1);
    });
    // ダブルクリックイベント
    this.dg_SearchResult.hostElement.addEventListener('dblclick', (e: DragEvent) => {
      this.eventDgSearchResult_ITEMDOUBLECLICKHandler(e);
    });

  }

  /**
   * コンテキストメニューを追加
   *
   * @memberof KYMW1403Component
   */
  setContextMenu(): void {
    this.contextMenu = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { caption: 'ページを開く', cmd: 'openPage', disabled: false },
        ],
        command: this.getFormatMenuCommand(),
        // イベント設定
        itemClicked: (s, e) => {
          switch (this.contextMenu.selectedValue) {
            case 'openPage':
              this.eventDgSearchResult_CONTEXTCLICKHandler();
              break;
          }
        }
      }
    );

    // 右クリック押下時 コンテキストメニュー表示処理
    this.dg_SearchResult.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.contextMenu !== undefined) {
        if (this.dg_SearchResult.selectedItems.length > 0) {
          this.contextMenu.itemsSource[0].disabled = false;
        } else {
          this.contextMenu.itemsSource[0].disabled = true;
        }
        this.contextMenu.show(e);
      }
    });

    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode('ページを開く');
  }

  /**
   * コンテキストメニューの活性制御
   *
   * @private
   * @returns
   * @memberof KYMW1403Component
   */
  private getFormatMenuCommand() {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        return !param.disabled;
      }
    };
  }

  /**
   * 検索ボタンを押下した時に呼び出されるメソッド。
   *
   * @returns {void}
   * @memberof KYMW1403Component
   */
  public eventBtnSearch_CLICKHandler(): void {
    // 検索前にDataGridをクリア
    this.kymw1403Model.publishGoodsArray = new Array<any>();

    // 受注コードの「開始」「終了はともに必須」
    if (PlessViewUtilsSub.isEmpty(this.kymw1403Model.orderCodeFrom) || PlessViewUtilsSub.isEmpty(this.kymw1403Model.orderCodeTo)) {
      // チェックエラーの場合は、メッセージを表示
      this.dialogService.openAlertGetMessage('W0001', ['受注コード(From)、受注コード(To)']);
      return;
    }

    // (1)受注コード大小相関チェック (From ≦ To)を行う。
    if (!(Number(this.kymw1403Model.orderCodeFrom) <= Number(this.kymw1403Model.orderCodeTo))) {
      // チェックエラーの場合は、メッセージを表示
      this.dialogService.openAlertGetMessage('E0123', ['受注コード']);
      return;
    }

    // 受注コード存在チェック
    if (!this.txt_OrderCodeFrom.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('W0024', ['受注コード(From)']);
      return;
    }
    if (!this.txt_OrderCodeTo.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('W0024', ['受注コード(To)']);
      return;
    }

    // (2) 検索ボタン押下時の検索条件を生成する
    // (3) 検索ボタン押下字の検索条件として、フィールドに退避させる
    // (4) 掲載商品一覧取得リクエスト用VOを編集
    this.publishGoodsDataVO = this.createPublishGoodsDataVO();

    // (5) サーバにデータ取得を要求(Cairngormイベント発行)
    this.getPublishGoodsDataService.execute(this.kymw1403Model, this.publishGoodsDataVO);
  }

  /**
   * 「前へ」ボタンを押下した時に呼び出されるメソッド
   *
   * @memberof KYMW1403Component
   */
  public eventBtnBack_CLICKHandler(): void {
    // 検索前にDataGridをクリア
    this.kymw1403Model.publishGoodsArray = new Array<any>();

    // 保持しているVOからページカウンタを-1する(デクリメントで-1)
    this.publishGoodsDataVO.page--;

    // サーバにデータ取得を要求(Cairngormイベント発行)
    this.getPublishGoodsDataService.execute(this.kymw1403Model, this.publishGoodsDataVO);
  }

  /**
   * 「次へ」ボタンを押下した時に呼び出されるメソッド
   *
   * @param {MouseEvent} event コールバック・イベントへの参照
   * @memberof KYMW1403Component
   */
  public eventBtnNext_CLICKHandler(): void {
    // 検索前にDataGridをクリア
    this.kymw1403Model.publishGoodsArray = new Array<any>();

    // 保持しているVOからページカウンタを+1する(インクリメントで+1)
    this.publishGoodsDataVO.page++;

    // サーバにデータ取得を要求(Cairngormイベント発行)
    this.getPublishGoodsDataService.execute(this.kymw1403Model, this.publishGoodsDataVO);
  }

  /**
   * 検索結果のデータグリッドのアイテム上でダブルクリックが発生した際のイベント
   *
   * @param {*} event コールバック・イベントへの参照
   * @memberof KYMW1403Component
   */
  public eventDgSearchResult_ITEMDOUBLECLICKHandler(event: any): void {
    // イベント発生元(データグリッド)のアイテムが選択状態か、「念のため」チェック
    if (this.dg_SearchResult.selectedItems.length > 0) {

    // ヘッダー内部がクリックされている場合は何もしない
    if (this.dg_SearchResult.hitTest(event).cellType === CellType.ColumnHeader              // カラムヘッダーである、
    ||  this.dg_SearchResult.hitTest(event).edgeLeft                                                // 左端、
    ||  this.dg_SearchResult.hitTest(event).edgeRight) {                                            // 右端の場合
      // 判定結果を返却
      return;
    }

      // 遷移元の『コマ割』画面に、ページ情報（受注コード、媒体区分、会員生協コード、ページID）を受渡し、コマ割画面側で選択ページに切り替える。
      this.setKYMW1403Parameter(this.createKYMW1403OutputVO(this.dg_SearchResult.selectedItems));
    }
  }

  /**
   * 検索結果のデータグリッドのアイテムを選択した状態で、コンテキストメニューから「開く」でクリックされた際のイベント
   *
   * @private
   * @memberof KYMW1403Component
   */
  public eventDgSearchResult_CONTEXTCLICKHandler(): void {
    // イベント発生元(データグリッド)のアイテムが選択状態か、「念のため」チェック
    if (this.dg_SearchResult.selectedItems.length > 0) {
      // 遷移元の『コマ割』画面に、ページ情報（受注コード、媒体区分、会員生協コード、ページID）を受渡し、コマ割画面側で選択ページに切り替える。
      this.setKYMW1403Parameter(this.createKYMW1403OutputVO(this.dg_SearchResult.selectedItems));
    }
  }

  /**
   * 検索結果のデータグリッドのヘッダが押下されたときのイベント
   *
   * @param {*} event コールバック・イベントへの参照
   * @memberof KYMW1403Component
   */
  public eventDgSearchResult_HEADERRELEASEHandler(event: any): void {
    // 後続のデフォルトイベントをキャンセル
    event.preventDefault();
    const field: string = this.tableName[this.dg_SearchResult.columns[this.dg_SearchResult.hitTest(event).col].binding];
    // 取得できなかったら何もしない
    if (!field) {
      return;
    }
    if (!DataGridUtil.isSortable(event, this.dg_SearchResult)) {
      return;
    }
    // データが0件の場合は何もしない
    if (this.kymw1403Model.publishGoodsArray.length !== 0) {
      // 検索前にDataGridをクリア
      this.kymw1403Model.publishGoodsArray = new Array<any>();

      // データグリッドのヘッダテキストを描画し、ASCとDESCをVOに設定
      this.publishGoodsDataVO.sortOrder = DataGridUtil.switchHeaderText(event, this.dg_SearchResult);
      this.kymw1403Model.sortOrder = this.publishGoodsDataVO.sortOrder;

      // クリックされたデータグリッドの列から、DBの物理項目を取得
      this.publishGoodsDataVO.sortItem = field;
      this.kymw1403Model.sortKey = this.publishGoodsDataVO.sortItem;

      // ページカウンタの初期化
      this.publishGoodsDataVO.page = 1;

      // サーバにデータ取得を要求(Cairngormイベント発行)
      this.getPublishGoodsDataService.execute(this.kymw1403Model, this.publishGoodsDataVO);
    }
  }

  /**
   * 掲載商品データ取得リクエスト用VOを作成する
   *
   * @private
   * @returns {PublishGoodsDataModel} 掲載商品データ取得リクエストVO
   * @memberof KYMW1403Component
   */
  private createPublishGoodsDataVO(): PublishGoodsDataModel {
    // 戻り値VOの生成
    const returnVO: PublishGoodsDataModel = new PublishGoodsDataModel();

    // 受注コード(From)の設定
    if (!PlessViewUtilsSub.isEmpty(this.kymw1403Model.orderCodeFrom)) {
      returnVO.orderCodeFrom = this.kymw1403Model.orderCodeFrom;
    }

    // 受注コード(To)の設定
    if (!PlessViewUtilsSub.isEmpty(this.kymw1403Model.orderCodeTo)) {
      returnVO.orderCodeTo = this.kymw1403Model.orderCodeTo;
    }

    // 商品案内用商品名
    returnVO.guideGoodsName = this.kymw1403Model.guideGoodsName;

    // Pコード
    returnVO.pCode = this.kymw1403Model.pCode;

    // 会員生協（茨城）チェック
    if (this.kymw1403Model.chbIbaraki) {
      returnVO.coopIbarakiChk = '1';
    }

    // 会員生協（栃木）チェック
    if (this.kymw1403Model.chbTochigi) {
      returnVO.coopTochigiChk = '1';
    }

    // 会員生協（群馬）チェック
    if (this.kymw1403Model.chbGunma) {
      returnVO.coopGunmaChk = '1';
    }

    // 会員生協（千葉）チェック
    if (this.kymw1403Model.chbChiba) {
      returnVO.coopChibaChk = '1';
    }

    // 会員生協（埼玉）チェック
    if (this.kymw1403Model.chbSaitama) {
      returnVO.coopSaitamaChk = '1';
    }

    // 会員生協（東京）チェック
    if (this.kymw1403Model.chbTokyo) {
      returnVO.coopTokyoChk = '1';
    }

    // 会員生協（長野）チェック
    if (this.kymw1403Model.chbNagano) {
      returnVO.coopNaganoChk = '1';
    }

    // 会員生協（新潟）チェック
    if (this.kymw1403Model.chbNiigata) {
      returnVO.coopNiigataChk = '1';
    }

    // 会員生協（クルコ）チェック
    if (this.kymw1403Model.chbKuruco) {
      returnVO.coopKurucoChk = '1';
    }

    returnVO.sortOrder = this.kymw1403Model.sortOrder;
    returnVO.sortItem = this.kymw1403Model.sortKey;

    return returnVO;
  }

  /**
   * 『コマ割』画面に引き渡すVOオブジェクトを生成する
   *
   * @private
   * @param {*} selectedItem 選択されたデータグリッドのオブジェクト
   * @returns {KYMW1403OutputModel}
   * @memberof KYMW1403Component
   */
  private createKYMW1403OutputVO(selectedItem: any): KYMW1403OutputModel {
    // 戻り値VOの生成
    const returnOutputVO: KYMW1403OutputModel = new KYMW1403OutputModel();

    // VOにデータグリッドからの値を設定する
    returnOutputVO.orderCode = selectedItem[0].OrderCode;			// 受注コード
    returnOutputVO.mediumType = selectedItem[0].MediumType;		// 媒体区分
    returnOutputVO.coopCode = selectedItem[0].CoopCode;			// 会員生協コード
    returnOutputVO.pageId = selectedItem[0].PageId;				// ページID
    returnOutputVO.pageNum = selectedItem[0].PageNum;				// ページ番号

    return returnOutputVO;
  }

  /**
   * 「前へ」「次へ」関連のボタンを更新する
   *
   * @memberof KYMW1403Component
   */
  public updatePagingButton(): void {
    // ボタンの活性・非活性を判定する
    this.judgeButtonEnable(this.kymw1403Model.startDispNum, this.kymw1403Model.endDispNum, this.kymw1403Model.totalNum);
  }

  /**
   * ボタンの活性・非活性を判定する
   *
   * @private
   * @param {number} startNum 開始件数
   * @param {number} endNum 終了件数
   * @param {number} totalNum 総件数
   * @param {*} [previousButton=null] 「前へ」ボタン
   * @param {*} [nextButton=null] 「次へ」ボタン
   * @memberof KYMW1403Component
   */
  private judgeButtonEnable(startNum: number, endNum: number, totalNum: number, previousButton: any = null, nextButton: any = null): void {
    // 「前へ」ボタンの活性・非活性の判定
    this.kymw1403Model.disabledPreviousButton = (startNum <= 1);

    // 「次へ」ボタンの活性・非活性の判定
    this.kymw1403Model.disabledNextButton = (endNum >= totalNum);
  }

}
